import { render, staticRenderFns } from "./Comparecientes.vue?vue&type=template&id=5bed1e44&scoped=true"
import script from "./Comparecientes.vue?vue&type=script&lang=js"
export * from "./Comparecientes.vue?vue&type=script&lang=js"
import style0 from "./Comparecientes.vue?vue&type=style&index=0&id=5bed1e44&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bed1e44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bed1e44')) {
      api.createRecord('5bed1e44', component.options)
    } else {
      api.reload('5bed1e44', component.options)
    }
    module.hot.accept("./Comparecientes.vue?vue&type=template&id=5bed1e44&scoped=true", function () {
      api.rerender('5bed1e44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/comparecientes/Comparecientes.vue"
export default component.exports